// Forked from api/msw/api/caseDocuments/index.ts at `cases-pre-sr-fork` (Service Requests start as a copy of Cases).
// Comments below were written for Cases and still describe this file until the two diverge.
import { makeDocumentAPIs } from '../../modules/documentAPIFactory'
import { getServiceRequestDocumentListData } from './mockData'
import type { IServiceRequestDocument } from '~/types/document/models'

export const {
  getDocuments: getServiceRequestDocuments,
  postDocument: postServiceRequestDocument,
  patchDocument: patchServiceRequestDocument,
  deleteDocument: deleteServiceRequestDocument,
  handlers,
} = makeDocumentAPIs<IServiceRequestDocument>({
  apiPathEntityNamePrefix: 'serviceRequest',
  getDocumentListDataFn: getServiceRequestDocumentListData,
})
